import styles from './UploadBar.module.css'
import { AnimatePresence, m } from 'motion/react'
import { followSpring } from '@/animation/transitions'
import { Spinner } from '@/components/Spinner'
import { Icon } from '@/components/Icon'
import { RawButton } from '@/components/Button'

export interface UploadBarProps {
  hidden: boolean
  autoDismiss: boolean
  dragging: boolean
  uploading: boolean
  currentlyUploadingFileName?: string
  docsPendingUpload: number
  remainingCount: number
  uploadPercent: number
  resolved: boolean
  successUploadCount: number
  firstSuccessUploadName?: string
  targetWorkspaceName: string
  onClose: () => unknown
}

export function UploadBar({
  hidden,
  autoDismiss,
  dragging,
  uploading,
  currentlyUploadingFileName,
  docsPendingUpload,
  remainingCount,
  uploadPercent,
  resolved,
  successUploadCount,
  firstSuccessUploadName,
  targetWorkspaceName,
  onClose,
}: UploadBarProps) {
  return (
    <AnimatePresence>
      {!hidden && (
        <m.div
          className={styles.root}
          initial={{ y: '100%' }}
          animate={{ y: 0 }}
          exit={{ y: '100%' }}
          transition={{ type: 'spring', ...followSpring }}
        >
          {dragging && (
            <div className={styles.draggingFiles}>
              Drop your files to upload to {targetWorkspaceName} document center
            </div>
          )}
          {uploading && (
            <div className={styles.inProgress}>
              <Spinner thickness={3} size={20} />
              <div className={styles.content}>
                <div>Uploading {currentlyUploadingFileName}</div>
                {docsPendingUpload > 0 && (
                  <>
                    <div> - </div>
                    <div className={styles.remainingCount}>
                      {remainingCount} documents left
                    </div>
                  </>
                )}
              </div>
              <div
                className={styles.progress}
                style={{
                  transform: `translateX(${uploadPercent}%)`,
                }}
              ></div>
            </div>
          )}
          {resolved && successUploadCount > 0 && (
            <div className={styles.resolved}>
              <div className={styles.resolvedInfo}>
                <Icon color="#70c79a" name="radio-checked" />
                <div>
                  {successUploadCount > 1 && (
                    <>
                      Uploaded {successUploadCount} files to{' '}
                      {targetWorkspaceName}
                    </>
                  )}
                  {successUploadCount === 1 && (
                    <>
                      Uploaded {firstSuccessUploadName} to {targetWorkspaceName}
                    </>
                  )}
                </div>
              </div>
              <RawButton
                className={styles.resolvedClose}
                onPress={() => onClose()}
              >
                {!autoDismiss && 'Close'}
              </RawButton>
            </div>
          )}
        </m.div>
      )}
    </AnimatePresence>
  )
}
